import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import AppLayout from '@layouts/AppLayout'
import AuthLayout from '@layouts/AuthLayout'
import Home from '@pages/Home'
import Login from '@pages/Login'
import Logout from '@pages/Logout'
import Exception from '@pages/Exception'
import Dashboard from '@pages/Dashboard'
import Vaccine from '@pages/Vaccine'
import HealthCheck from '@pages/HealthCheck'
import Development from '@pages/Development'
import Weight from '@pages/Weight'
import Height from '@pages/Height'
import Hospital from '@pages/Hospital'
import Specialty from '@pages/Specialty'
import User from '@pages/User'
import Promotion from '@pages/Promotion'
import Article from '@pages/Article'
import RewardsList from '@pages/RewardsList'
import ReswardStore from '@pages/ReswardStore'
import ReswardSpecialEvent from '@pages/ReswardSpecialEvent'
import CollectCoins from '@pages/CollectCoins'
import Blog from '@pages/Blog'
import Activity from '@pages/Activity'
import ClubMember from '@pages/ClubMember'
import ClubECoupon from '@pages/ClubECoupon'
import ClubPrivileges from '@pages/ClubPrivileges'
import BabyWaitingApprove from '@pages/BabyWaitingApprove'
import BabyApproved from '@pages/BabyApproved'
import DiscountCode from '@pages/DiscountCode'
import Campaign from '@pages/Campaign'

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      <Route path="/not-found">
        <Exception code="404" />
      </Route>
      <Route path={['/login']}>
        <AuthLayout>
          <Route exact path="/login">
            <Login />
          </Route>
        </AuthLayout>
      </Route>
      <Route
        path={[
          '/dashboard',
          '/vaccines',
          '/health-check',
          '/development',
          '/weight',
          '/height',
          '/hospitals',
          '/dialog-chat',
          '/articles',
          '/blogs',
          '/rewards-list',
          '/shop',
          '/special-event',
          '/collector-coins',
          '/promotion',
          '/member',
          '/eCoupon',
          '/privileges',
          '/activities',
          '/users',
          '/babyWaitingApprove',
          '/babyApproved',
          '/discount-code',
          '/logout',
          '/campaign',
        ]}
      >
        <AppLayout>
          <Route path="/dashboard">
            <Dashboard />
          </Route>
          <Route path="/vaccines">
            <Vaccine />
          </Route>
          <Route path="/health-check">
            <HealthCheck />
          </Route>
          <Route path="/development">
            <Development />
          </Route>
          <Route path="/weight">
            <Weight />
          </Route>
          <Route path="/height">
            <Height />
          </Route>
          <Route path="/hospitals">
            <Hospital />
          </Route>
          <Route path="/specialties">
            <Specialty />
          </Route>
          <Route exact path="/dialog-chat">
            <Dashboard />
          </Route>
          <Route path="/articles">
            <Article />
          </Route>

          <Route path="/blogs">
            <Blog />
          </Route>

          <Route path="/rewards-list">
            <RewardsList />
          </Route>
          <Route path="/shop">
            <ReswardStore />
          </Route>
          <Route path="/special-event">
            <ReswardSpecialEvent />
          </Route>
          <Route path="/collector-coins">
            <CollectCoins />
          </Route>

          <Route path="/promotion">
            <Promotion />
          </Route>
          <Route path="/campaign">
            <Campaign />
          </Route>
          <Route path="/member">
            <ClubMember />
          </Route>
          <Route path="/eCoupon">
            <ClubECoupon />
          </Route>
          <Route path="/privileges">
            <ClubPrivileges />
          </Route>
          <Route path="/activities">
            <Activity />
          </Route>
          <Route path="/users">
            <User />
          </Route>
          <Route path="/babyWaitingApprove">
            <BabyWaitingApprove />
          </Route>
          <Route path="/babyApproved">
            <BabyApproved />
          </Route>
          <Route path="/discount-code">
            <DiscountCode />
          </Route>
          <Route exact path="/logout">
            <Logout />
          </Route>
        </AppLayout>
      </Route>
      <Route path="*">
        <Redirect to="/not-found" />
      </Route>
    </Switch>
  )
}

export default Routes
